"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformVehicleTypeToKeyString = transformVehicleTypeToKeyString;
const legacy_enums_1 = require("@daytrip/legacy-enums");
function transformVehicleTypeToKeyString(vehicleType) {
    switch (vehicleType) {
        case legacy_enums_1.VehicleType.Sedan:
            return "sedan";
        case legacy_enums_1.VehicleType.Mpv:
            return "mpv";
        case legacy_enums_1.VehicleType.Van:
            return "van";
        case legacy_enums_1.VehicleType.Shuttle:
            return "shuttle";
        case legacy_enums_1.VehicleType.LuxurySedan:
            return "luxurySedan";
        case legacy_enums_1.VehicleType.SedanLite:
            return "sedanLite";
        case legacy_enums_1.VehicleType.MpvLite:
            return "mpvLite";
        case legacy_enums_1.VehicleType.VanLite:
            return "vanLite";
        default:
            return null;
    }
}
//# sourceMappingURL=transformVehicleTypeToKeyString.js.map